import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisualIdentificationComponent } from './visual-identification.component';
import { VisualIdentificationRoutingModule } from './visual-identification-routing.module';
import { SelectableBorderComponent } from './selectable-border/selectable-border.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from '@shared/shared.module';
import { ImagePredictionComponent } from './image-prediction/image-prediction.component';
import { ReceiptViewerComponent } from './receipt-viewer/receipt-viewer.component';
import { PopupComponent } from './receipt-viewer/popup/popup.component';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { PredictResultComponent } from './predict-result/predict-result.component';


@NgModule({
  declarations: [    
    VisualIdentificationComponent,
    SelectableBorderComponent,
    ImagePredictionComponent,
    ReceiptViewerComponent,
    PopupComponent,
    PredictResultComponent    
  ],
  imports: [
    CommonModule,       
    VisualIdentificationRoutingModule, 
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule, 
  ],
  entryComponents: [PopupComponent],
})
export class VisualIdentificationModule { }
